export const debounce = (func: any, time: number = 100) => {
  let timer: NodeJS.Timeout
  return function(event: any) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, time, event)
  }
}
